module.exports = __webpack_public_path__ + "static/media/hero-image-mobile@2x.1257f99d.jpg";